import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { IDurationMenuItem } from "../interfaces/IDurationMenuItem";

export const getDaysDataSet = (numDays: number): Array<IDurationMenuItem> => {
    const dataSet: Array<IDurationMenuItem> = [];
    for (let i = 1; i <= numDays; i++) {
        dataSet.push({
            value: userUiI18n.getPluralString("temporary_access.steps.select_days.days", { count: i, numDays: i.toString() }),
            numberOfDays: i
        });
    }
    return dataSet;
};
